import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HierarchyType } from './hierarchy-type.enum';
import { HierarchyNodeSelectDto } from './hierarchy-node/hierarchy-node.model';

@Injectable({
    providedIn: 'root'
})
export class HierarchyService {
    private httpClient = inject(HttpClient);

	/**
	 * Get a Hierarchy Tree for the given Hierarchy Type starting at the single Root Node associated with the User. 
	 * sysAdmins automatically get the full hierarchy
	 */
    getHierarchyTree(subscriberKey: number, hierarchyType: HierarchyType, includeSuppressedNodes?: boolean, includeChildlessInnerNodes?: boolean) {
		const params = {
			hierarchyType: hierarchyType,
			includeSuppressedNodes: includeSuppressedNodes ?? false,
			includeChildlessInnerNodes: includeChildlessInnerNodes ?? false
		};

        return this.httpClient.get<HierarchyNodeSelectDto>(`api/subscriber/${subscriberKey}/hierarchy-nodes/tree`, { params: params });
    }
}
